import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormComponent } from '@formbird/types';
import { ChangedDocumentService, FormbirdInjectorService } from 'formbird-services';
import { Subscription } from 'rxjs';
import { ComponentSetupService } from '../component-setup.service';
import { AbstractComponent } from './abstract.component';

@Component({
  template: '' // template will be overridden in child component
})
export abstract class AbstractDocumentComponent<T> extends AbstractComponent<T> implements FormComponent, OnInit {

  protected subs: Subscription = new Subscription();

  protected constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }
  ngOnInit(): void {
    super.ngOnInit();

    const docSub = this.changedDocumentService.watchDocument(this.document.documentId).subscribe(doc => {

      // console.log('On document change from store: ', this.document.documentId);

      this.document = doc;

    });

    this.subs.add(docSub);

  }

}
